import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import "./HomeComponent.scss";
import {
	BookIconFilled,
	BookIconOutline,
	GradCapIconFilled,
	GradCapIconOutline,
	StudentIconFilled,
	StudentIconOutline,
	SuitcaseIconFilled,
	SuitcaseIconOutline,
} from "../../shared/component/svg/Icons";
import CardContainer from "../../shared/component/CardContainer/CardContainer";
import { CollegeCard, MajorCard } from "../../shared/component/Card/Card";
import SecondaryHeader from "../../container/Header/SecondaryHeader";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import BannerCarousel from "../../shared/component/BannerCarousel/BannerCarousel";

const LOADING_CARD = [...Array(4)].map((i) => ({
	isLoading: true,
}));
const LOADING_CARD_RECENT_VIEW = [...Array(5)].map((i) => ({
	isLoading: true,
}));

const HomeComponent = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [collegeRecentView, setCollegeRecentView] = useState(null);
	const [majorRecentView, setMajorRecentView] = useState(null);
	const [collegeRec, setCollegeRec] = useState(null);
	const [majorRec, setMajorRec] = useState(null);
	const [showSecondaryBar, setShowSecondaryBar] = useState(null);
	const controlBarRef = useRef();

	useEffect(() => {
		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.5,
		};

		const observer = new IntersectionObserver((entries) => {
			const [entry] = entries;
			setShowSecondaryBar(!entry.isIntersecting);
		}, options);

		if (controlBarRef.current) {
			observer.observe(controlBarRef.current);
		}

		return () => {
			observer.disconnect();
		};
	}, []);

	useEffect(() => {
		getDashboardData();
	}, [isAuthenticated]); // eslint-disable-line

	const getDashboardData = async (count = 0) => {
		if (count > 3) return;
		setIsLoading(true);

		let res = await makeRequest(generateRequestOptions("dashboard"));

		if (res?.code === 200) {
			setCollegeRecentView(res?.data?.recently_viewed_colleges || []);
			setMajorRecentView(res?.data?.recently_viewed_majors || []);
			setCollegeRec(res?.data?.recommended_colleges || []);
			setMajorRec(res?.data?.recommended_majors || []);
		} else {
			setTimeout(() => {
				getDashboardData(count + 1);
			}, 750);
		}

		setIsLoading(false);
	};

	return (
		<div className="home-component">
			{showSecondaryBar && <SecondaryHeader />}
			<div className="container hc-cont">
			{/* <Image className="full-width-banner" src={Banner} alt="banner" /> */}
			<BannerCarousel />
				<div className="hc-btn-action" ref={controlBarRef}>
					<Link to={RoutePath.COLLEGE} className="btn btn-hc">
						<div className="btn-icon">
							<StudentIconOutline
								className="icon-standby"
								width="2.4rem"
								height="2.4rem"
								stroke="white"
							/>
							<StudentIconFilled className="icon-hover" width="2.4rem" height="2.4rem" fill="white" />
						</div>
						{Variable.COLLEGE[ENV_NAME]}
					</Link>
					<Link to={RoutePath.MAJOR} className="btn btn-hc">
						<div className="btn-icon">
							<BookIconOutline className="icon-standby" width="2.4rem" height="2.4rem" stroke="white" />
							<BookIconFilled className="icon-hover" width="2.4rem" height="2.4rem" fill="white" />
						</div>
						{Variable.MAJOR[ENV_NAME]}
					</Link>
					<Link to={RoutePath.SCHOLARSHIP} className="btn btn-hc">
						<div className="btn-icon">
							<GradCapIconOutline
								className="icon-standby"
								width="2.4rem"
								height="2.4rem"
								stroke="white"
							/>
							<GradCapIconFilled className="icon-hover" width="2.4rem" height="2.4rem" fill="white" />
						</div>
						{Variable.SCHOLARSHIP[ENV_NAME]}
					</Link>
					<Link to={RoutePath.CAREER} className="btn btn-hc">
						<div className="btn-icon">
							<SuitcaseIconOutline
								className="icon-standby"
								width="2.4rem"
								height="2.4rem"
								stroke="white"
							/>
							<SuitcaseIconFilled className="icon-hover" width="2.4rem" height="2.4rem" fill="white" />
						</div>
						{Variable.CAREER[ENV_NAME]}
					</Link>
				</div>
				{isAuthenticated && (isLoading || collegeRecentView?.length > 0) && (
					<section className="recently-viewed mb-lg">
						<div className="d-flex align-items-center mb-lg">
							<h3 className="me-md font-weight-semibold mb-0">
								{Variable.RECENTLY_VIEW_COLLEGE[ENV_NAME]}
							</h3>
						</div>
						<CardContainer className="recently-view-grid">
							{(isLoading ? LOADING_CARD_RECENT_VIEW : collegeRecentView || LOADING_CARD_RECENT_VIEW).map(
								(i, idx) => (
									<Link
										key={"college-recent-" + (i?.recently_viewed_id || idx)}
										to={i?.college__id ? RoutePath.COLLEGE_DETAIL + "/" + i?.college__id : ""}
										className="text-decoration-none text-label-dark-gray-2"
									>
										<CollegeCard
											isLoading={i?.isLoading}
											data={i?.isLoading ? undefined : i}
											onClickFavorite={() => {
												if (i?.isLoading || fetchingAddRemoveFavorites) return;
												if (isAuthenticated) {
													props.addRemoveFavorite(
														i?.is_fav ? "remove" : "add",
														"college",
														i?.is_fav ? i?.fav_id : i?.college__id,
														(res) => {
															setCollegeRecentView((prev) =>
																prev.map((p) => {
																	if (p?.college__id !== i?.college__id) return p;
																	return {
																		...p,
																		is_fav: !i?.is_fav,
																		fav_id: i?.is_fav ? null : res?.data?.id,
																	};
																})
															);
														}
													);
												} else {
													props.openLoginModal();
												}
											}}
											ENV_NAME={ENV_NAME}
											recentlyviewedcard={1}
										/>
									</Link>
								)
							)}
						</CardContainer>
					</section>
				)}
				{isAuthenticated && (isLoading || majorRecentView?.length > 0) && (
					<section className="recently-viewed mb-lg">
						<div className="d-flex align-items-center mb-lg">
							<h3 className="me-md font-weight-semibold mb-0">
								{Variable.RECENTLY_VIEW_MAJOR[ENV_NAME]}
							</h3>
						</div>
						<CardContainer className="recently-view-grid">
							{(isLoading ? LOADING_CARD_RECENT_VIEW : majorRecentView || LOADING_CARD_RECENT_VIEW).map(
								(i, idx) => (
									<Link
										key={"major-recent-" + (i?.recently_viewed_id || idx)}
										to={i?.major__id ? RoutePath.MAJOR_DETAIL + "/" + i?.major__id : ""}
										className="text-decoration-none text-label-dark-gray-2"
									>
										<MajorCard
											isLoading={i?.isLoading}
											data={i?.isLoading ? undefined : i}
											onClickFavorite={() => {
												if (i?.isLoading || fetchingAddRemoveFavorites) return;
												if (isAuthenticated) {
													props.addRemoveFavorite(
														i?.is_fav ? "remove" : "add",
														"major",
														i?.is_fav ? i?.fav_id : i?.major__id,
														(res) => {
															setMajorRecentView((prev) =>
																prev.map((p) => {
																	if (p?.major__id !== i?.major__id) return p;
																	return {
																		...p,
																		is_fav: !i?.is_fav,
																		fav_id: i?.is_fav ? null : res?.data?.id,
																	};
																})
															);
														}
													);
												} else {
													props.openLoginModal();
												}
											}}
											ENV_NAME={ENV_NAME}
											recentlyviewedcard={1}
										/>
									</Link>
								)
							)}
						</CardContainer>
					</section>
				)}
				{(isLoading || collegeRec?.length > 0) && (
					<section className="recommendation mb-lg">
						<div className="d-flex align-items-center mb-lg">
							<h3 className="me-md font-weight-semibold mb-0">
								{Variable.OUR_COLLEGE_RECOMMENDATION[ENV_NAME]}
							</h3>
							<Link to={RoutePath.COLLEGE} className="text-decoration-none">
								<h4 className="view-all-text mb-0">{Variable.VIEW_ALL[ENV_NAME]}</h4>
							</Link>
						</div>
						<CardContainer>
							{(isLoading ? LOADING_CARD : collegeRec || LOADING_CARD).map((i, idx) => (
								<Link
									key={"college-rec-" + (i?.id || idx)}
									to={i?.id ? RoutePath.COLLEGE_DETAIL + "/" + i?.id : ""}
									className="text-decoration-none text-label-dark-gray-2"
								>
									<CollegeCard
										isLoading={i?.isLoading}
										data={i?.isLoading ? undefined : i}
										onClickFavorite={() => {
											if (i?.isLoading || fetchingAddRemoveFavorites) return;
											if (isAuthenticated) {
												props.addRemoveFavorite(
													i?.is_fav ? "remove" : "add",
													"college",
													i?.is_fav ? i?.fav_id : i?.id,
													(res) => {
														setCollegeRec((prev) =>
															prev.map((p) => {
																if (p?.id !== i?.id) return p;
																return {
																	...p,
																	is_fav: !i?.is_fav,
																	fav_id: i?.is_fav ? null : res?.data?.id,
																};
															})
														);
													}
												);
											} else {
												props.openLoginModal();
											}
										}}
										ENV_NAME={ENV_NAME}
									/>
								</Link>
							))}
						</CardContainer>
					</section>
				)}
				{(isLoading || majorRec?.length > 0) && (
					<section className="recommendation mb-lg">
						<div className="d-flex align-items-center mb-lg">
							<h3 className="me-md font-weight-semibold mb-0">
								{Variable.OUR_MAJOR_RECOMMENDATION[ENV_NAME]}
							</h3>
							<Link to={RoutePath.MAJOR} className="text-decoration-none">
								<h4 className="view-all-text mb-0">{Variable.VIEW_ALL[ENV_NAME]}</h4>
							</Link>
						</div>
						<CardContainer>
							{(isLoading ? LOADING_CARD : majorRec || LOADING_CARD).map((i, idx) => (
								<Link
									key={"major-rec-" + (i?.id || idx)}
									to={i?.id ? RoutePath.MAJOR_DETAIL + "/" + i?.id : ""}
									className="text-decoration-none text-label-dark-gray-2"
								>
									<MajorCard
										isLoading={i?.isLoading}
										data={i?.isLoading ? undefined : i}
										onClickFavorite={() => {
											if (i?.isLoading || fetchingAddRemoveFavorites) return;
											if (isAuthenticated) {
												props.addRemoveFavorite(
													i?.is_fav ? "remove" : "add",
													"major",
													i?.is_fav ? i?.fav_id : i?.id,
													(res) => {
														setMajorRecentView((prev) =>
															prev.map((p) => {
																if (p?.id !== i?.id) return p;
																return {
																	...p,
																	is_fav: !i?.is_fav,
																	fav_id: i?.is_fav ? null : res?.data?.id,
																};
															})
														);
													}
												);
											} else {
												props.openLoginModal();
											}
										}}
										ENV_NAME={ENV_NAME}
									/>
								</Link>
							))}
						</CardContainer>
					</section>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(HomeComponent));
